import axios from "axios";

//const BASE_URL = "https://admin.susipizza.in/api";

//const BASE_URL = "http://localhost:4000";

const BASE_URL = process.env.REACT_APP_API_URL;

const LoginUserapi = async (data) => {
  const response = await axios.post(`${BASE_URL}/auth/login`, data);
  return response;
};

const AddCategory = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/category/add`, data, {
    headers: { Authorization: token },
  });

  return response;
};

const DeleteCategory = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/category/${id}`, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const UpdateCategory = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/category/${id}`, data, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const GetCategories = async () => {
  const response = await axios.get(`${BASE_URL}/category`);
  return response;
};

const AddCity = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/city/add`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteCity = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/city/${id}`, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const UpdateCity = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/city/${id}`, data, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const GetCities = async () => {
  const response = await axios.get(`${BASE_URL}/city`);
  return response;
};

const AddDeliveryBoy = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/delivery/add`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteDeliveryBoy = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/delivery/${id}`, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const UpdateDeliveryBoy = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/delivery/${id}`, data, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const DisableRider = async (token, id) => {
  const response = await axios.put(`${BASE_URL}/delivery/disable/${id}`, {}, {
    headers: { Authorization: token },
  });
  return response;
};

const EnableRider = async (token, id) => {
  const response = await axios.put(`${BASE_URL}/delivery/enable/${id}`, {}, {
    headers: { Authorization: token },
  });
  return response;
};

const ResetRiderPassword = async (token, id, newPassword) => {
  const response = await axios.put(`${BASE_URL}/delivery/reset-password/${id}`, { newPassword }, {
    headers: { Authorization: token },
  });
  return response;
};

const GetDeliveryHistory = async (token) => {
  const response = await axios.get(`${BASE_URL}/delivery/history`, {
    headers: { Authorization: token },
  });
  return response;
};

// Was unauthenticated and unscoped (returned every rider platform-wide to
// anyone). Now requires a token; a store-tied admin's own store's riders
// come back automatically, no separate lookup needed.
const GetDeliveryBoys = async (token) => {
  const response = await axios.get(`${BASE_URL}/delivery`, {
    headers: { Authorization: token },
  });
  return response;
};

const AddStores = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/store/add`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteStores = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/store/${id}`, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};

const UpdateStores = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/store/${id}`, data, {
    headers: {
      Authorization: token,
    },
  });
  return response;
};
const GetStores = async () => {
  const response = await axios.get(`${BASE_URL}/store`);
  return response;
};

const GetStoreMenu = async (storeId) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${BASE_URL}/store-menu?storeId=${storeId}`, {
    headers: { Authorization: token },
  });
  return response;
};

const AssignProductToStore = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/store-menu/assign`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const CloneStoreMenu = async (token, sourceStoreId, targetStoreId) => {
  const response = await axios.post(
    `${BASE_URL}/store-menu/clone`,
    { sourceStoreId, targetStoreId },
    { headers: { Authorization: token } },
  );
  return response;
};

const UpdateStoreProduct = async (token, data) => {
  const response = await axios.put(`${BASE_URL}/store-menu/update`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const RemoveProductFromStore = async (token, storeId, productId) => {
  const response = await axios.delete(`${BASE_URL}/store-menu/remove?storeId=${storeId}&productId=${productId}`, {
    headers: { Authorization: token },
  });
  return response;
};

const SaveStoreMenuOrder = async (token, storeId, orderedProductIds) => {
  const response = await axios.put(`${BASE_URL}/store-menu/reorder`, { storeId, orderedProductIds }, {
    headers: { Authorization: token },
  });
  return response;
};


const AddPromotion = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/promotions/add`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdatePromotion = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/promotions/${id}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeletePromotion = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/promotions/${id}`, {
    headers: { Authorization: token },
  });
  return response;
};

// Was unauthenticated — every promotions CRUD route had no auth at all
// before. Now requires a token; a store-tied admin automatically sees only
// their own store's promotions (server-side filtered).
const GetPromotions = async (token) => {
  const response = await axios.get(`${BASE_URL}/promotions`, {
    headers: { Authorization: token },
  });
  return response;
};

// Token-scoped: superadmin gets the business-wide view, a store-tied admin
// gets their own store's view automatically (server branches on the JWT's
// role/storeId — see server/apis/routes/dashboard.js). Replaces the old
// pair of GetDashboardData()/GetDashboardDataByUserName(username), the
// latter of which hit an unauthenticated username-keyed route.
const GetDashboardData = async (token) => {
  const response = await axios.get(`${BASE_URL}/dashboard/data`, {
    headers: { Authorization: token },
  });
  return response;
};

const GetAllUsers = async (token) => {
  const response = await axios.get(`${BASE_URL}/users/all`, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateUserStatus = async (token, userId, status) => {
  const response = await axios.put(`${BASE_URL}/users/${userId}/status`, { status }, {
    headers: { Authorization: token },
  });
  return response;
};

const ResetUserPassword = async (token, userId, newPassword) => {
  const response = await axios.put(`${BASE_URL}/users/${userId}/reset-password`, { newPassword }, {
    headers: { Authorization: token },
  });
  return response;
};

const AssignStoreToUser = async (token, userId, storeId) => {
  const response = await axios.put(`${BASE_URL}/users/${userId}/assign-store`, { storeId }, {
    headers: { Authorization: token },
  });
  return response;
};

const UnlockUserAccount = async (token, userId) => {
  const response = await axios.put(`${BASE_URL}/users/${userId}/unlock`, {}, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateUserDetails = async (token, userId, data) => {
  const response = await axios.put(`${BASE_URL}/users/${userId}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteUser = async (token, userId) => {
  const response = await axios.delete(`${BASE_URL}/users/${userId}`, {
    headers: { Authorization: token },
  });
  return response;
};

const AssignStoreAdmin = async (token, storeId, data) => {
  const response = await axios.post(`${BASE_URL}/store/${storeId}/assign-admin`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const GetAllOrders = async (token) => {
  const response = await axios.get(`${BASE_URL}/order`, {
    headers: { Authorization: token },
  });
  return response;
};

const StatusUpdate = async (id, data, token) => {
  const response = await axios.put(`${BASE_URL}/order/status/${id}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdatePaymentStatus = async (id, paymentStatus, token) => {
  const response = await axios.put(
    `${BASE_URL}/order/payment-status/${id}`,
    { paymentStatus },
    { headers: { Authorization: token } }
  );
  return response;
};

const ProcessRefund = async (token, id) => {
  const response = await axios.post(
    `${BASE_URL}/order/refund/${id}`,
    {},
    { headers: { Authorization: token } }
  );
  return response;
};

// Was unauthenticated and unscoped, same issue as GetDeliveryBoys above.
// Now requires a token; a store-tied admin automatically gets only their
// own store's available riders — replaces the old
// GetAvailableDeliverybyStore(storename), which matched against a
// `stores.username` field current store creation doesn't even set (the
// same broken pattern fixed for orders — see GetMyStoreOrders above).
const GetAvailableDeliveryPart = async (token) => {
  const response = await axios.get(`${BASE_URL}/delivery/available`, {
    headers: { Authorization: token },
  });
  return response;
};

const AssignDeliveryBoy = async (token, id, data) => {
  const response = await axios.post(
    `${BASE_URL}/order/assign-delivery-boy/${id}`,
    data,
    { headers: { Authorization: token } }
  );
  return response;
};


// Was GetOrdersByUserName(username) — hit a completely unauthenticated
// endpoint that resolved the store via a `stores.username` field current
// store creation no longer sets. The backend now infers the caller's own
// store directly from their token (a store-tied admin can't be pointed at
// another store's orders even by tampering with a request), so this just
// needs the token, not a username.
const GetMyStoreOrders = async (token) => {
  const response = await axios.get(`${BASE_URL}/order/getorders/store`, {
    headers: { Authorization: token },
  });
  return response;
}

// Cursor-paginated order list — only reads the page actually requested.
// `cursor` is the {seconds, nanoseconds} nextCursor from the previous page
// (omit/null for page 1). Works for both admin (store-scoped) and
// superadmin (global) — resolveStoreScope on the server handles that split.
const GetOrdersPage = async (token, { tab = "all", limit = 20, cursor = null } = {}) => {
  const params = { tab, limit };
  if (cursor) {
    params.cursorSeconds = cursor.seconds;
    params.cursorNanoseconds = cursor.nanoseconds || 0;
  }
  const response = await axios.get(`${BASE_URL}/order/page`, {
    headers: { Authorization: token },
    params,
  });
  return response;
};

// Metric-card counts/revenue via server-side aggregation — cheap regardless
// of how many orders exist, unlike deriving them from a fully-loaded list.
const GetOrderMetrics = async (token) => {
  const response = await axios.get(`${BASE_URL}/order/metrics`, {
    headers: { Authorization: token },
  });
  return response;
};

const AddBanner = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/banners/add`, data, {
    headers: { Authorization: token },
  });
  return response;
}

const UpdateBanner = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/banners/update/${id}`, data, {
    headers: { Authorization: token },
  });
  return response;
}

const DeleteBanner = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/banners/delete/${id}`, {
    headers: {
      Authorization: token,
    },
  });
  return response;
}

const GetBanners = async () => {
  const response = await axios.get(`${BASE_URL}/banners`);
  return response;
}

const ChangeRiderPassword = async (token, data) => {
  const response = await axios.put(`${BASE_URL}/delivery/user/changePassword`, data, {
    headers: {
      Authorization: token,
    },
  })
  return response
}

const GetDeliverySettings = async (token, storeId) => {
  const response = await axios.get(`${BASE_URL}/delivery-settings/${storeId}`, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateDeliverySettings = async (token, storeId, data) => {
  const response = await axios.put(`${BASE_URL}/delivery-settings/${storeId}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const GetVariants = async () => {
  const response = await axios.get(`${BASE_URL}/variants`);
  return response;
};

const AddVariant = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/variants/add`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateVariant = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/variants/${id}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteVariant = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/variants/${id}`, {
    headers: { Authorization: token },
  });
  return response;
};

const GetProducts = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.search) params.append('search', filters.search);
  if (filters.categoryId) params.append('categoryId', filters.categoryId);
  if (filters.veg !== undefined && filters.veg !== '') params.append('veg', filters.veg);
  if (filters.status) params.append('status', filters.status);

  const response = await axios.get(`${BASE_URL}/products?${params.toString()}`);
  return response;
};

const GetProductById = async (id) => {
  const response = await axios.get(`${BASE_URL}/products/${id}`);
  return response;
};

const AddProduct = async (token, data) => {
  const response = await axios.post(`${BASE_URL}/products`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateProduct = async (token, id, data) => {
  const response = await axios.put(`${BASE_URL}/products/${id}`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const DeleteProduct = async (token, id) => {
  const response = await axios.delete(`${BASE_URL}/products/${id}`, {
    headers: { Authorization: token },
  });
  return response;
};

const FindNearestStore = async (latitude, longitude) => {
  const response = await axios.post(`${BASE_URL}/api/location/find-store`, { latitude, longitude });
  return response;
};

const CalculateDeliveryPlayground = async (token, payload) => {
  const response = await axios.post(`${BASE_URL}/delivery-settings/playground/calculate`, payload, {
    headers: { Authorization: token },
  });
  return response;
};

const AssignStore = async (latitude, longitude) => {
  const response = await axios.post(`${BASE_URL}/api/location/assign-store`, { latitude, longitude });
  return response;
};

const RevalidateSession = async (latitude, longitude, assignedStoreId, items) => {
  const response = await axios.post(`${BASE_URL}/api/location/revalidate-session`, { latitude, longitude, assignedStoreId, items });
  return response;
};

const EvaluatePromotion = async (payload) => {
  const response = await axios.post(`${BASE_URL}/promotion/evaluate`, payload);
  return response;
};

const CreateOrder = async (token, payload) => {
  const response = await axios.post(`${BASE_URL}/order/create`, payload, {
    headers: { Authorization: token },
  });
  return response;
};

const GetAppConfig = async () => {
  const response = await axios.get(`${BASE_URL}/app-config`);
  return response;
};

const UpdateAppConfig = async (token, data) => {
  const response = await axios.put(`${BASE_URL}/app-config`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const GetAuditLog = async (token, params = {}) => {
  const response = await axios.get(`${BASE_URL}/audit-log`, {
    headers: { Authorization: token },
    params,
  });
  return response;
};

const GetBusinessSettings = async (token) => {
  const response = await axios.get(`${BASE_URL}/business-settings`, {
    headers: { Authorization: token },
  });
  return response;
};

const UpdateBusinessSettings = async (token, data) => {
  const response = await axios.put(`${BASE_URL}/business-settings`, data, {
    headers: { Authorization: token },
  });
  return response;
};

const GetPaymentGatewayStatus = async (token) => {
  const response = await axios.get(`${BASE_URL}/payment-settings/status`, {
    headers: { Authorization: token },
  });
  return response;
};

const GetPayments = async (token) => {
  const response = await axios.get(`${BASE_URL}/payments`, {
    headers: { Authorization: token },
  });
  return response;
};

export {
  LoginUserapi,
  GetAppConfig,
  UpdateAppConfig,
  AddCategory,
  DeleteCategory,
  UpdateCategory,
  GetCategories,
  AddDeliveryBoy,
  DeleteDeliveryBoy,
  UpdateDeliveryBoy,
  GetDeliveryBoys,
  AddStores,
  DeleteStores,
  UpdateStores,
  GetStores,
  GetStoreMenu,
  AssignProductToStore,
  CloneStoreMenu,
  UpdateStoreProduct,
  RemoveProductFromStore,
  SaveStoreMenuOrder,
  AddPromotion,
  UpdatePromotion,
  DeletePromotion,
  GetPromotions,
  GetDashboardData,
  GetAllUsers,
  GetAllOrders,
  AddCity,
  DeleteCity,
  UpdateCity,
  GetCities,
  StatusUpdate,
  UpdatePaymentStatus,
  ProcessRefund,
  GetAvailableDeliveryPart,
  AssignDeliveryBoy,
  GetMyStoreOrders,
  GetOrdersPage,
  GetOrderMetrics,
  AddBanner,
  UpdateBanner,
  DeleteBanner,
  GetBanners,
  ChangeRiderPassword,
  DisableRider,
  EnableRider,
  ResetRiderPassword,
  GetDeliveryHistory,
  GetDeliverySettings,
  UpdateDeliverySettings,
  GetVariants,
  AddVariant,
  UpdateVariant,
  DeleteVariant,
  GetProducts,
  GetProductById,
  AddProduct,
  UpdateProduct,
  DeleteProduct,
  FindNearestStore,
  CalculateDeliveryPlayground,
  AssignStore,
  RevalidateSession,
  EvaluatePromotion,
  CreateOrder,
  UpdateUserStatus,
  ResetUserPassword,
  AssignStoreToUser,
  UnlockUserAccount,
  UpdateUserDetails,
  DeleteUser,
  AssignStoreAdmin,
  GetAuditLog,
  GetBusinessSettings,
  UpdateBusinessSettings,
  GetPaymentGatewayStatus,
  GetPayments,
};

